const contentStatus = {
  Draft: { value: 'Draft', label: 'Draft' },
  PendingReview: { value: 'PendingReview', label: 'Pending Review' },
  Published: { value: 'Published', label: 'Published' },
  UnPublished: { value: 'UnPublished', label: 'Un-Published' },
  Archived: { value: 'Archived', label: 'Archived' }
};

export default contentStatus;



// WEBPACK FOOTER //
// ./src/constants/content-status.js